import { ScreenContainer } from 'components';
import { useTranslation } from 'react-i18next';
import image from 'assets/images/forgot-password-success.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Space, Typography } from 'antd';

const StyledImage = styled.img`
  height: 70%;
`;

export const ForgotSuccessPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();

  function onSubmit() {
    navigate('/login', { replace: true });
  }

  return (
    <ScreenContainer>
      <Space direction="vertical" align="center">
        <StyledImage src={image} alt="" />

        {state === 'login' && <Typography.Title level={3}>{t('forgetLoginId.complete')}</Typography.Title>}
        {state === 'password' && <Typography.Title level={3}>{t('forgetPassword.complete')}</Typography.Title>}
        {state === 'password-reset' && <Typography.Title level={3}>{t('resetPassword.successTitle')}</Typography.Title>}

        {state === 'login' && <Typography.Text type="secondary">{t('forgetLoginId.success')}</Typography.Text>}
        {state === 'password' && <Typography.Text type="secondary">{t('forgetPassword.success')}</Typography.Text>}
        {state === 'password-reset' && (
          <Typography.Text type="secondary">{t('resetPassword.successMessage')}</Typography.Text>
        )}

        <Button type="primary" data-testid={'submitButton'} onClick={onSubmit} style={{ marginTop: 16 }}>
          {t('login.returnToLogin')}
        </Button>
      </Space>
    </ScreenContainer>
  );
};
